import * as screenActions from '../../Common/actions/Screen';
import * as templateFieldActions from './Field';
import {
    showWarnMessage,
    showInfoMessage
} from '../../../../_shared/Messages/actions/MessageActions';
import templateTexts from '../texts';
import {messagesIds} from '../../../../_shared/Messages/consts';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {saveData, insertFields, changeScreen} from '../../SystemReport/actions/Screen';
import moment from 'moment';

let addNewTemplateServer;

export function initFunctions(funcs) {
    if (funcs) {
        screenActions.initFunctions(funcs);
        templateFieldActions.initFunctions(funcs);
        addNewTemplateServer = funcs.addNewTemplate;
    }
}

export function createNewTemplate(designScreen, title, lang) {
    title = title === '' ? designScreen.collection.generatedTitle : title;

    let isDouble = false;
    for (let i = 0; i < designScreen.collection.fields.length && !isDouble; i++) {
        if (designScreen.collection.fields[i].isDouble(designScreen.collection.fields[i], title)) {
            isDouble = true;
        }
    }
    if (isDouble) {
        showWarnMessage({
            id: messagesIds.screens.createTemplateWarn,
            title: getLocalizedText(texts.duplicateTemplateErr)
        });
    } else {
        const field = designScreen.createNewField({
            name: designScreen.nextId,
            template: -1,
            title: title,
            readonly: false,
            filetime: moment().format('DD/MM/YYYY HH:mm'),
            lang: lang
        });
        designScreen.collection.addField(field);
        addNewTemplateServer(title, lang);
        showInfoMessage({
            title: templateTexts.newTemplateMessageTitle,
            content: templateTexts.newTemplateMessageContent
        });
    }
}

export const templatesScreenActions = {
    changeScreen,
    initFunctions,
    insertFields,
    saveData
};
